import { CartCalculationRule, CartDomainContext } from '../cart.domain';
import { RegularPriceStrategy, CashPriceStrategy, RegularModifierPriceStrategy, CashModifierPriceStrategy } from '../strategies';

export class CartItemPriceUnitCalculationRule implements CartCalculationRule {
	private readonly regularStrategy = new RegularPriceStrategy();
	private readonly cashStrategy = new CashPriceStrategy();

	private readonly regularModifierStrategy = new RegularModifierPriceStrategy();
	private readonly cashModifierStrategy = new CashModifierPriceStrategy();

	/**
	 * Calcular el precio de los items del carrito con cada metodo de pago.
	 * @param context CartDomainContext
	 * @returns CartDomainContext
	 */
	public calculate(context: CartDomainContext): CartDomainContext {
		const processMenuItem = context.menuItems.map(menuItem => {
			// Obtiene precio del menu item por metodo de pago
			const regularPrice = this.regularStrategy.calculationTotal(menuItem);
			const cashPrice = this.cashStrategy.calculationTotal(menuItem);

			// Obtiene precio de modificadores por metodo de pago
			const regularModiferPrice = this.regularModifierStrategy.calculationModifiersTotal(menuItem);
			const cashModiferPrice = this.cashModifierStrategy.calculationModifiersTotal(menuItem);

			// Precio unitario por metodo de pago
			const regularUnitPrice = regularPrice + regularModiferPrice;
			const cashUnitPrice = cashPrice + cashModiferPrice;

			return {
				...menuItem,
				price: regularUnitPrice,
				priceCash: cashUnitPrice,
			};
		});

		return {
			...context,
			menuItems: processMenuItem,
		};
	}
}
